import React from "react";

import styles from "./ExchangeYear.module.scss";

const ExchangeYear = () => {
  return (
    <div className={styles.container}>
      <div className={styles.contents}>
        <p className={styles.title}>
          {new Date().getFullYear()}
          年度授業実施前の重要なお知らせ
        </p>
        <div className={styles.messages}>
          <a
            className={styles.messageLink}
            href="https://3lsbz.share.hsforms.com/2f40WOLFTT2CaLOqvUM7Vhw"
            target="_blank"
            rel="noreferrer"
          >
            ・「納品前確認フォーム」へのご回答をお願いいたします
          </a>
          <a
            className={styles.messageLink}
            href={`${process.env.REACT_APP_MANAGER_URL}/manager/exchange_school_year`}
            target="_blank"
            rel="noreferrer"
          >
            ・年度更新についてご確認ください
          </a>
        </div>
      </div>
    </div>
  );
};

export default ExchangeYear;
